import React from 'react';
import { createRoot } from 'react-dom/client';
import { Form } from '../../../component/review/add/Form';
import Client from '../../../model/api/Client';

const element = document.getElementById('add-review-form');

if (element) {
	const root = createRoot(element);
	const client = new Client();
	root.render(
		<Form
			defaultSlug={element.dataset.slug}
			apiClient={client}
			codexUrl={element.dataset.codexUrl}
			companyName={element.dataset.companyName}
		/>
	);
}
